<template>
    <section class="property-neighborhood section-outline">
        <div class="grid xs-grid-cols-1">
            <div>
                <h2 class="f2 text-bold">Around {{ glb.geo?.neighborhood || 'Neighborhood' }}</h2>
                <div class="f5 text-gray">
                  Explore everything this neighborhood has to offer.
                  <a :href="glb.appUrl + dpp.geo.neighborhoodPagePath" class="link text-bold" v-if="dpp.geo.neighborhoodPagePath">Learn more about {{ glb.geo?.neighborhood || '' }}.</a>
                </div>
                <div class="f5 text-gray m-t-2">
                    <a  class="link text-bold" v-if="dpp.geo.neighborhoodPath" :href="glb.appUrl + dpp.geo.neighborhoodPath"> View homes for sale in {{ dpp.geo.neighborhood }}  <i class="icon-angle-right f7"></i></a>
                    <a  class="link text-bold" v-else-if="dpp.geo.zipcodePath" :href="glb.appUrl + dpp.geo.zipcodePath"> View homes for sale in {{ dpp.geo.zipcode }}, {{ dpp.geo.state }} <i class="icon-angle-right f7"></i></a>
                </div>
            </div>
            <div class="grid grid-cols-2 sm-grid-cols-4 m-t-2" v-if="cards && cards.length">
                <div class="score-card" v-for="(card, i) in cards" :key="i">
                    <div>
                      <i :class='`f1 icon-${card.icon}`'></i>
                      <button type="button" :aria-label="`More information about ${card.title} rating.`"  v-tip :tip="card.info"><i class="icon-Info-Circle f5"></i></button>
                    </div>
                    <div><span class="f2">{{ card.score }}</span><span>/100</span></div>
                    <div class='text-bold f6'>{{ card.title }} <span v-if="card.info"></span></div>
                </div>
            </div>
            <button class="property-mapview" type="button"  :aria-label="molang('dpp.propertyButton.map')" @click="popMapView" data-link-name="Map">
                <span class="circle"><i class="icon-expand"></i></span>
                <div class="flex center tip-box">
                    <div class="tip">
                        <span class="f7 text-bold">Home you're viewing</span>
                    </div>
                </div>
                <div class="property-mapview-pin">
                    <i class="f1" :class="dpp.propertyTypeIcon"></i>
                </div>
                <mvtMapStatic :newDpp="true" :anchor="'center'" class="img" :height="400" :width="400" :lat="dpp.geo.lat" :lng="dpp.geo.lng"
                zoom="13" type="roadmap" :address="dpp.geo.formatAddress"></mvtMapStatic>
            </button>
        </div>
    </section>
</template>
<script src="./property-neighborhood.js"></script>
<style lang="scss">
@use "./property-neighborhood.scss" as *;
</style>